import { ColorTypes } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { directTreasuryMarketStatusQuery } from '../../../../../store/product/selectors';
import { ProductButtonProps } from '../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const DirectTreasurySellButton: React.FC<ProductButtonProps<'directTreasurySell'>> = (
  props
) => {
  const buttonColor: ColorTypes.Option = useBreakpointValue({
    base: 'neutral.white' as ColorTypes.Option,
    lg: 'neutral.darkest' as ColorTypes.Option,
  });
  const { data } = useRecoilQuery(directTreasuryMarketStatusQuery);

  const forceButtonDisable = !data || !data?.isOpen;

  return (
    <ApplicationButton
      {...props}
      buttonText="Resgatar"
      buttonVariant="secondary"
      buttonColor={buttonColor}
      backgroundColor="neutral.white"
      isDisabled={props.isDisabled || forceButtonDisable}
      idSelector="productId"
    />
  );
};
